export enum StockQuantityByMusicSystemBrandTypes {
    //Grid
    GET_STOCK_QUANTITY_BY_MUSIC_SYSTEM_BRAND_LIST_LOADING = "@@stockQtyBySupplier/GET_STOCK_QUANTITY_BY_MUSIC_SYSTEM_BRAND_LIST_LOADING",
    GET_STOCK_QUANTITY_BY_MUSIC_SYSTEM_BRAND_LIST_SUCCESS = "@@stockQtyBySupplier/GET_STOCK_QUANTITY_BY_MUSIC_SYSTEM_BRAND_LIST_SUCCESS",
    GET_STOCK_QUANTITY_BY_MUSIC_SYSTEM_BRAND_LIST_ERROR = "@@stockQtyBySupplier/GET_STOCK_QUANTITY_BY_MUSIC_SYSTEM_BRAND_LIST_ERROR",

    GET_AUDIO_BRAND_LOADING = "@@stockQtyByMusicSystemBrand/GET_AUDIO_BRAND_LOADING",
    GET_AUDIO_BRAND_SUCCESS = "@@stockQtyByMusicSystemBrand/GET_AUDIO_BRAND_SUCCESS",
    GET_AUDIO_BRAND_ERROR = "@@stockQtyByMusicSystemBrand/GET_AUDIO_BRAND_ERROR",
  }